// extracted by mini-css-extract-plugin
export var contact = "Contact-module--contact--6e56d";
export var contactList = "Contact-module--contact-list--8a25b";